import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useDynamicFontSize = () => {
	const { width } = useSelector((state) => state.App);

	const fontSizes = useMemo(() => {
		if (width <= 1080) {
			return { titleFontSize: 14, subtitleFontSize: 12, propFontSize: 22 };
		} else if (width <= 1512) {
			return { titleFontSize: 14, subtitleFontSize: 12, propFontSize: 10 };
		} else if (width <= 1920) {
			return { titleFontSize: 14, subtitleFontSize: 12, propFontSize: 12 };
		} else {
			return { titleFontSize: 14, subtitleFontSize: 12, propFontSize: 14 };
		}
	}, [width]);

	return fontSizes;
};

export default useDynamicFontSize;
